import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { useSiteSettings } from "../contexts/SiteSettingsContext";

const Footer = () => {
  const { settings } = useSiteSettings();

  return (
    <footer className="bg-[#120f1f] pt-12 text-white/85">
      <div className="mx-auto grid w-full max-w-6xl gap-8 sm:gap-10 px-4 sm:px-5 pb-12 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-4">
          <img
            src={`${process.env.PUBLIC_URL}/Lingua_Logo.png`}
            alt="The Lingua Alliance"
            className="h-16 sm:h-20 w-auto"
          />
          <p className="text-sm leading-relaxed text-white/70">
            The Lingua Alliance empowers confident global communicators through
            immersive, internationally aligned language education.
          </p>
        </div>

        <div className="space-y-4">
          <h4 className="text-sm font-semibold uppercase tracking-wide text-white">
            Our Courses
          </h4>
          <nav className="flex flex-col gap-2 text-sm text-white/70">
            <Link className="transition hover:text-white" to="/french">
              French
            </Link>
            <Link className="transition hover:text-white" to="/german">
              German
            </Link>
            <Link className="transition hover:text-white" to="/spanish">
              Spanish
            </Link>
            <Link className="transition hover:text-white" to="/japanese">
              Japanese
            </Link>
          </nav>
        </div>

        <div className="space-y-4">
          <h4 className="text-sm font-semibold uppercase tracking-wide text-white">
            Our Company
          </h4>
          <nav className="flex flex-col gap-2 text-sm text-white/70">
            <Link className="transition hover:text-white" to="/who-we-are">
              About us
            </Link>
            <Link className="transition hover:text-white" to="/services">
              Services
            </Link>
            <Link className="transition hover:text-white" to="/blogs">
              Blogs
            </Link>
            <Link className="transition hover:text-white" to="/contact">
              Contact us
            </Link>
          </nav>
        </div>

        <div className="space-y-4">
          <h4 className="text-sm font-semibold uppercase tracking-wide text-white">
            Get In Touch
          </h4>
          <p className="text-xs sm:text-sm text-white/70">
            Email: {settings.email}
          </p>
          <p className="text-xs sm:text-sm text-white/70">Phone: {settings.phone}</p>
          <p className="text-xs sm:text-sm text-white/70">
            {settings.address}
          </p>
          <div className="mt-3 flex items-center gap-2 sm:gap-3 text-base sm:text-lg text-white">
            <a
              href={settings.facebook}
              target="_blank" rel="noopener noreferrer"
              aria-label="Facebook"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 transition hover:bg-primary hover:text-white"
            >
              <FaFacebookF />
            </a>
            <a
              href={settings.instagram}
              target="_blank" rel="noopener noreferrer"
              aria-label="Instagram"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 transition hover:bg-primary hover:text-white"
            >
              <FaInstagram />
            </a>
            <a
              href={settings.linkedin}
              target="_blank" rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 transition hover:bg-primary hover:text-white"
            >
              <FaLinkedinIn />
            </a>
            <a
              href={settings.youtube}
              target="_blank" rel="noopener noreferrer"
              aria-label="YouTube"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 transition hover:bg-primary hover:text-white"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>

      {/* Certification Logos Section */}
      <div className="border-t border-white/10 py-6 sm:py-8">
        <div className="mx-auto max-w-6xl px-4 sm:px-5">
          <div className="bg-[#f0f7ff] rounded-lg p-4 sm:p-6 md:p-8">
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 md:gap-8">
              <div className="flex items-center justify-center">
                <img
                  src={`${process.env.PUBLIC_URL}/flogo-1.webp`}
                  alt="ISO 9001:2015 Certified"
                  className="h-14 sm:h-16 md:h-20 w-auto object-contain"
                />
              </div>
              <div className="flex items-center justify-center">
                <img
                  src={`${process.env.PUBLIC_URL}/flogo-2.webp`}
                  alt="MSME Registered"
                  className="h-14 sm:h-16 md:h-20 w-auto object-contain"
                />
              </div>
              <div className="flex items-center justify-center">
                <img
                  src={`${process.env.PUBLIC_URL}/flogo-4.webp`}
                  alt="Startup India"
                  className="h-14 sm:h-16 md:h-20 w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-4 sm:py-6">
        <div className="mx-auto flex max-w-6xl flex-col gap-3 sm:gap-4 px-4 sm:px-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3 sm:gap-4">
            <p className="text-xs text-white/60">
              Copyright © {new Date().getFullYear()} The Lingua Alliance. All
              rights reserved.
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center sm:justify-end gap-4 sm:gap-6">
            <Link
              to="/terms-and-conditions"
              className="text-xs text-white/60 hover:text-white transition-colors"
            >
              Terms & Conditions
            </Link>
            <Link
              to="/privacy-policy"
              className="text-xs text-white/60 hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/refund-policy"
              className="text-xs text-white/60 hover:text-white transition-colors"
            >
              Refund Policy
            </Link>
            <Link
              to="/cancellation-policy"
              className="text-xs text-white/60 hover:text-white transition-colors"
            >
              Cancellation Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
